import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions';
import { indexBy, prop } from 'ramda';
import * as _ from 'lodash';

const initialValues = { site: 'All', title: '', type: 'All', sponsor: '', time: 'All Time', active: false };

const defaultState = {
  current: {},
  series: [],
  posts: [],
  seriesMap: {},
  seriesQuery: initialValues,
  loading: false,
  seriesScope: null,
};

const reducer = handleActions(
  {
    [combineActions(actions.series.getSeries)]: state => {
      return { ...state, loading: true };
    },
    [combineActions(actions.series.getSeriesSuccess)]: (state, { payload: { series = [], siteId } }) => {
      const noDates = series.filter(r => !r?.data?.startDate);
      const withDates = series.filter(r => r?.data?.startDate);

      series = [..._.sortBy(withDates, 'data.timestamp'), ...noDates];

      return {
        ...state,
        loading: false,
        series,
        seriesMap: indexBy(prop('id'), series),
        seriesScope: siteId ?? state.seriesScope,
      };
    },
    [combineActions(actions.series.getSeriesFail)]: state => {
      return { ...state, loading: false };
    },
    [combineActions(actions.series.getSeriesPostsSuccess)]: (state, { payload: { posts = [] } }) => {
      return { ...state, posts };
    },
    [combineActions(actions.series.setSeriesQuery)]: (state, { payload: { seriesQuery } }) => {
      return { ...state, seriesQuery: seriesQuery || initialValues };
    },
    [combineActions(actions.series.getSeriesPostsFail)]: (state, { payload: { posts = [] } = {} }) => {
      return { ...state, posts };
    },
    [combineActions(actions.series.clearSeriesCache)]: (state, { payload }) => {
      return { ...defaultState };
    },
    [combineActions(actions.series.updateSeriesSuccess)]: (state, { payload: { series } }) => {
      const updatedSeries = state.series.map(s => (s.id === series.id ? series : s));
      return {
        ...state,
        series: updatedSeries,
        seriesMap: indexBy(prop('id'), updatedSeries),
      };
    },
  },
  defaultState
);

export default reducer;
